const POPULAR_CAR_MAKERS = [286, 212, 278, 429];

const POPULAR_CAR_MODEL_LINES = {
  286: [11299, 11292, 11290, 11921, 11302, 12484],
  212: [11253, 11247, 12483, 11248, 12325, 11244],
  278: [11280, 11281, 12428, 12315, 11275, 11283],
  429: [12240, 12437, 12017, 12357, 12183, 12066],
};

export function sortWithPopularsFirst(items, popularIds) {
  const populars = [];
  const others = [];

  items.forEach((item) => {
    if (popularIds.includes(parseInt(item.value, 10))) {
      populars.push({ ...item, isPopular: true, label: `${item.label} ⭐` });
    } else {
      others.push(item);
    }
  });

  populars.sort(
    (a, b) =>
      popularIds.indexOf(parseInt(a.value, 10)) -
      popularIds.indexOf(parseInt(b.value, 10)),
  );

  return [...populars, ...others];
}

export function transformMakers(makers) {
  const transformed = makers.map((maker) => ({
    ...maker,
    value: maker.id.toString(),
    label: maker.name,
  }));

  return sortWithPopularsFirst(transformed, POPULAR_CAR_MAKERS);
}

export function transformModelLines(models, makerId) {
  const transformed = models.map((model) => ({
    ...model,
    value: model.id.toString(),
    label: model.name,
  }));

  const popular = POPULAR_CAR_MODEL_LINES[parseInt(makerId, 10)] || [];
  return sortWithPopularsFirst(transformed, popular);
}

export function getYearsFromConfigurations(configurations) {
  const currentYear = new Date().getFullYear();
  const yearSet = new Set();

  configurations.forEach((config) => {
    const start = config.yearStart;
    const end = config.yearEnd || currentYear;

    for (let year = start; year <= end; year += 1) {
      yearSet.add(year);
    }
  });

  return Array.from(yearSet)
    .sort((a, b) => a - b)
    .map((year) => ({
      value: year.toString(),
      label: year.toString(),
    }));
}

export function getModificationLabel(modification) {
  let label = modification.name || '';

  if (modification.fuelType) {
    label += `/${modification.fuelType}`;
  }
  if (modification.engineType) {
    label += `/${modification.engineType}`;
  }
  if (modification.emissionNorms) {
    label += `/${modification.emissionNorms}`;
  }

  return label;
}

export function transformModifications(configurations) {
  return configurations.map((config) => ({
    ...config,
    value: config.id.toString(),
    label: getModificationLabel(config),
    oemUrl: config.oemUrl,
  }));
}
